export default __webpack_public_path__ + "static/media/turtle-1.99cc3649.png";